import { Component, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Address } from '@spartacus/core'

@Component({
  selector: 'mb-checkout-tax-exemption-form-partial',
  templateUrl: './mb-checkout-tax-exemption-form-partial.component.html',
  styleUrls: ['./mb-checkout-tax-exemption-form-partial.component.scss']
})
export class MbCheckoutTaxExemptionFormPartialComponent {

  @Input() formGroup: UntypedFormGroup | undefined
  @Input() address: Address = {}
  isSalesTaxExemption = false

  setTaxExemptionValue () {
    this.isSalesTaxExemption = !this.isSalesTaxExemption
    this.formGroup?.patchValue({ taxExempt: this.isSalesTaxExemption })
  }
}
